import React from 'react'
import PropTypes from 'prop-types'
import { compose, pickAll } from 'ramda'
import withStyle from './Header.style.js'

const validProps = ['type', 'children', 'className', 'data-testid', 'style'] // add to this list as needed

const Header = (props) => {
  const filteredProps = pickAll(validProps, props)

  return React.createElement(
    filteredProps.type,
    { ...filteredProps },
    filteredProps.children
  )
}

Header.defaultProps = {
  type: 'h1',
}

Header.propTypes = {
  /** Header HTML Tag */
  type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),
  /** Header Text. */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Header props. */
  props: PropTypes.object,
  /** ClassName  */
  className: PropTypes.string,
  /** Whtie */
  white: PropTypes.bool,
  /** Style */
  style: PropTypes.object,
  /** data-testid */
  'data-testid': PropTypes.string,
}

export default compose(withStyle)(Header)
